import Layout from "../../components/Layout/Layout"
import SitesTable from "./features/SitesTable"
import SitesFilter from "./features/SitesFilters"
import useSitesAccess from "./useSitesAccess"
import UnauthorizedAccess from "../Error/401"
import useSitesTable from "./features/SitesTable/useSitesTable"

const SitesComponent = () => {
    const { states, functions } = useSitesTable()
    const { viewSitesTable } = useSitesAccess()
    if (viewSitesTable)
        return (
            <>
                <SitesFilter tableStates={states} tableFunctions={functions} />
                <SitesTable states={states} functions={functions} />
            </>
        )
    return <UnauthorizedAccess />
}

const Sites = () => {
    return <Layout heading="Sites" subHeading="" children={<SitesComponent />} />
}
export default Sites
